<template>
  <wrap-container>
    <help-title title="Desconocimiento de Consumo" />

    <help-list-container>
      <help-list-item tituloLista="Teléfonos útiles:">
        Para realizar el desconocimiento de un consumo de tu Tarjeta de Débito
        comunicate con Prisma Medios de Pago al 4379-3394 de 9 a 21 hs. Desde
        allí realizarán las gestiones correspondientes y te brindarán una
        respuesta.
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    ContactLink
  }
};
</script>
